import React, { Component } from 'react'
import MediaQuery from 'react-responsive'

// JS
import { MOBILEDEVICEWIDTH, DESKTOPTABLETDEVICEWIDTH } from '../../utils/constants'

// CSS
import './NREOverview.css'

class NREOverview extends Component {
    render() {
        return (
            <div>
                <MediaQuery minDeviceWidth={DESKTOPTABLETDEVICEWIDTH} className="nre-overview" component="ul">
                    {this.props.children}
                </MediaQuery>

                <MediaQuery maxDeviceWidth={MOBILEDEVICEWIDTH} className="nre-overview mobile extra-margin" component="ul">
                    {this.props.children}
                </MediaQuery>
            </div>
        )
    }
}

export default NREOverview;


// WEBPACK FOOTER //
// ./src/components/nreoverview/NREOverview.js